import $ from 'jquery';
import {getUrlParams, kill} from './utilities';
import { emitter } from './emitter';
import 'moment';

/**
 * This module controls the filter on the news page and the people views
 *
 * @module filter
 * @version 0.1.1
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-06 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-11-30 using ChatGPT
 */

class Filter {
  constructor(element) {
    this.$el = $(element);
    
    this.setMembers();
    this.setInitialState();
    this.setupBinds();

    this.filterMobileTrigger();
  }

  setMembers() {
    this.$clearAll = this.$el.find('.clearAll');
    this.$search = this.$el.find('#search');
    this.$dropdown = this.$el.find('.dropdown');
    this.$letter = this.$el.find('.alphabet__letter');
    this.$letterDropdown = this.$el.find('.alphabet-dropdown');
  }

  setInitialState() {
    this.currentState = {
      'search': '',
      'dropdowns': {},
      'letter': '',
      'date': { 'from': '', 'to': '' }
    };

    const GET = getUrlParams();
    Object.keys(GET).forEach((key) => {
      const $select = this.$el.find(`select[data-reference='${key}']`);
      if ($select.find(`option[value='${GET[key]}']`).length !== 0) {
        $select.val(GET[key]);
      }
    });

    this.currentState.search = GET.search || '';
    this.currentState.letter = GET.letter || '';
    this.currentState.dropdowns.practiceGroup = GET.practiceGroup || '';
    this.currentState.dropdowns.industryGroup = GET.industryGroup || '';
    this.currentState.dropdowns.lawSchool = GET.lawSchool || '';
    this.currentState.dropdowns.type = GET.type || '';

    this.$search.val(this.currentState.search);
    this.$el.find(`.alphabet__letter[data-reference='${this.currentState.letter}']`).addClass('active');
    this.$letterDropdown.val(this.currentState.letter);
  }

  setupBinds() {
    this.$search.on('keyup', (evt) => {
      if (evt.key === 'Enter') {
        this.getSearchValue(evt);
      }
    });

    this.$search.on('focusout', this.getSearchValue.bind(this));
    this.$dropdown.on('change', this.getDropdownValue.bind(this));

    this.$letter.on('click',(evt) => {
      kill(evt);
      const $clicked = $(evt.currentTarget);
      let letter = $clicked.data('reference');
      if ($clicked.hasClass('active')) {
        letter = '';
      }
      this.setLetterValue(letter);
    });

    this.$letterDropdown.on('change', this.updateLetterFromDropdown.bind(this));
    emitter.on('queryForInitialState', this.publishState.bind(this));
    this.$clearAll.on('click', this.clearSelections.bind(this));
  }

  clearSelections() {
    this.$search.val('');
    this.currentState.letter = '';
    this.currentState.search = '';
    Object.keys(this.currentState.dropdowns).forEach(key => {
      this.currentState.dropdowns[key] = '';
    });
    this.$dropdown.each(function () { this.selectedIndex = 0; });
    this.$letter.removeClass('active');
    this.publishState();
  }

  updateLetterFromDropdown() {
    this.setLetterValue(this.$letterDropdown.val());
  }

  getSearchValue(evt) {
    if (this.currentState.search === evt.currentTarget.value) {
      return;
    }
    this.currentState.search = evt.currentTarget.value;
    this.publishState();
  }

  getDropdownValue(evt) {
    const reference = $(evt.currentTarget).data('reference');
    this.currentState.dropdowns[reference] = evt.currentTarget.value;
    this.publishState();
  }

  setLetterValue(letter) {
    this.$letter.removeClass('active');
    this.$letter.filter(`[data-reference='${letter}']`).addClass('active');
    this.currentState.letter = letter;
    this.$letterDropdown.val(letter);
    this.publishState();
  }

  publishState() {
    emitter.emit('updateFilter', this.currentState);
  }

  filterMobileTrigger() {
    this.$el.find('.filterTrigger').on('click',function () {
      $(this).children('i').toggleClass('icon-chevron-down icon-chevron-up');
      $(this).siblings('.filterWrapper').slideToggle('fast', function () {
        $(this).filter(':hidden').css('display', '');
      });
    });
  }
}

export default Filter;
